<span *ngIf="count">&nbsp;<span class="badge"
    [ngClass]="{'badge-light': !isOverdue && !isSoonOverdue, 'badge-warning': isSoonOverdue, 'badge-danger': isOverdue}">{{count}}</span></span>